import { Alert, Col, Placeholder, Row } from "react-bootstrap";
import ProjectItem from "../ProjectItem/ProjectItem";

const ProjectsList = ({ projects = [], isLoading = false, error = null }) => {
  if (isLoading && projects.length === 0) {
    return (
      <Row className="g-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <Col xs={12} md={6} lg={4} key={`project-skeleton-${index}`}>
            <article className="project-card project-card-skeleton">
              <Placeholder as="h5" animation="glow" className="mb-3">
                <Placeholder xs={9} />
              </Placeholder>
              <Placeholder as="p" animation="glow" className="mb-2">
                <Placeholder xs={5} />
              </Placeholder>
              <Placeholder as="p" animation="glow" className="mb-0">
                <Placeholder xs={7} />
              </Placeholder>
            </article>
          </Col>
        ))}
      </Row>
    );
  }

  if (!isLoading && !projects.length && !error) {
    return (
      <article className="projects-empty-state text-center">
        <h5 className="mb-2">No projects yet</h5>
        <p className="mb-0">Create the first project to start assigning activities and members.</p>
      </article>
    );
  }

  if (error && !projects.length) {
    return <Alert variant="danger">{String(error)}</Alert>;
  }

  return (
    <Row className="g-3">
      {projects.map((project, index) => (
        <Col xs={12} md={6} lg={4} key={project?.id ?? `project-${index}`}>
          <ProjectItem project={project} />
        </Col>
      ))}
    </Row>
  );
};

export default ProjectsList;
